import Styles from './ReferenceImage.module.scss'
import { ReferenceImageProps } from 'screens/Schedule/PostPromptsSection/Types'
import { useBrandKitColors } from 'screens/Calendar/WeekViewV2/hooks/useBrandKitColors'
import { LoadingColorState } from 'screens/Calendar/WeekViewV2/CalendarEventCard/LoadingColorState'
import { DEFAULT_LOADING_COLOR } from 'screens/Calendar/WeekViewV2/utils'
import { useReferenceImageSync } from 'hooks/queries/schedules/contents/useReferenceImage'
import { useCreateReferenceImage } from 'hooks/queries/schedules/contents/useCreateReferenceImage'
import dayjs from 'dayjs'
import { ErrorReferenceImage } from 'screens/Schedule/PostPromptsSection/ErrorReferenceImage'
import { UpdateReferenceImageTrigger } from 'screens/Schedule/PostPromptsSection/UpdateReferenceImageTrigger'
import { ReferenceImageButton } from 'screens/Schedule/PostPromptsSection/ReferenceImageButton'
import { LoadingShimmerer } from 'screens/Schedule/PostPromptsSection/ReferenceImg'

export const LoadingImage = () => {
  const brandKitColors = useBrandKitColors()

  return (
    <LoadingColorState
      loadingColor={brandKitColors?.[0] || DEFAULT_LOADING_COLOR}
      generationStartedAt={dayjs().toISOString()}
    />
  )
}

export const ReferenceImage = ({ scheduleId, contentId, height = 178, width = 178 }: ReferenceImageProps) => {
  const { mutate: createReferenceImage } = useCreateReferenceImage()
  const { data: referenceImage } = useReferenceImageSync(
    { scheduleId, contentId },
    {
      onSuccess: (data) => {
        if (!data.media_file && !data.status) {
          createReferenceImage({ scheduleId, contentId })
        }
      },
    },
  )

  if (!referenceImage) {
    return <LoadingShimmerer />
  }

  const status = referenceImage.status

  if (['pending', 'processing'].includes(status || '')) {
    return (
      <div className={Styles.image}>
        <LoadingImage />
      </div>
    )
  }

  if (!referenceImage.media_file?.source_url) {
    return <ErrorReferenceImage scheduleId={scheduleId} contentId={contentId} />
  }

  return (
    <UpdateReferenceImageTrigger scheduleId={scheduleId} contentId={contentId}>
      <ReferenceImageButton referenceMediaFile={referenceImage.media_file} />
    </UpdateReferenceImageTrigger>
  )
}
